/**
 * Currency Utilities
 * Centralized currency formatting and symbol functions
 */

import { siteConfig } from '@/config/site';

// Default currency from site config
export const DEFAULT_CURRENCY = siteConfig.payment.currency; // 'EUR'

// Default locale for EUR formatting (Irish English - displays as €1,234.56)
export const DEFAULT_LOCALE = 'en-IE';

/**
 * Get currency symbol for a given currency code
 */
export function getCurrencySymbol(currency: string = DEFAULT_CURRENCY): string {
  const symbols: Record<string, string> = {
    USD: '$',
    CAD: '$',
    AUD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    CNY: '¥',
  };
  return symbols[currency] || currency;
}

/**
 * Format amount with currency symbol using Intl.NumberFormat
 */
export function formatCurrency(
  amount: number,
  currency: string = DEFAULT_CURRENCY,
  locale: string = DEFAULT_LOCALE
): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Format amount as hourly rate
 */
export function formatHourlyRate(
  amount: number,
  currency: string = DEFAULT_CURRENCY,
  locale: string = DEFAULT_LOCALE
): string {
  return `${formatCurrency(amount, currency, locale)}/hr`;
}
